import styles from "./index.module.css";
import CardSlider from "../../../Components/CardSlider";
import Clampable from "../../../Components/CardSlider/Clampable";
import Anas from "./anastas.jpg";
import Kat from "./kat.jpg";
import Axler from "./axler.jpg";
import ver from "./ver.jpg";
import UNK from "./unkown.jpg";
import inv from "./inv.jpg";
import nast from "./nast.jpg";
import anna from "./anna.jpg";
import dast from "./dast.jpg";
import yana from "./yana.jpg";
import vadim from "./vadim.jpg";
import mmir from "./mmir.jpg";
import ddis from "./ddis.jpg";
import kuko from "./kuko.jpg";
import fedy from "./fedy.jpg";
import mat from "./mat.jpg";
import Ira from "./Ira.jpg";
import bor from "./bor.jpg";
import mar from "./mar.jpg";
import myt from "./myt.jpg";
import an from "./an.jpg";
import sof from "./sof.jpg";
import ir from "./ir.jpg";
import nad from "./nad.jpg";
import ihor from "./ihor.jpg";
import marion from "./marion.jpg";
import illa from "./illa.jpg";
import al from "./al.jpg";
import olya from "./olya.jpg";
import yadan from "./yadan.jpg";
import igor from "./igor.jpg";
import tat from "./tat.jpg";
import yar from "./yar.jpg";
import alyona from "./alyona.jpg";
import vikt from "./vikt.jpg";
import iloossha from "./iloossha.jpg";
import aeffir_ from "./aeffir_.jpg";
import bbrvasveth from "./bbrvasveth.jpg";
import vladi_ye from "./vladi.ye.jpg";
import darishka_semenyuk from "./darishka_semenyuk.jpg";
import shchutiak_ from "./shchutiak_.jpg";
import meinsplitter from "./meinsplitter.jpg";
import karina_kuznetsssova from "./karina_kuznetsssova.jpg";
import k_stasiaaaa from "./k_stasiaaaa.jpg";

const feedback = [
  {
    name: "Victoria",
    tag: "viktoriiuus",
    pfp: vikt,
    text: `Hey hey, sorry for being super late with this🫪

Overall, I'm super grateful and so satisfied with everything: it was intensive, helpful, and fun, all at once😎
What I loved: the atmosphere was always warm, supportive and easy-going, which really helped me relax and actually absorb the material. The lessons felt well-structured, and I appreciated that we always covered new words, phrases, grammar and still had time to laugh.

  About the teachers: each of you brought something special. Diana was super structured and fast-paced, I loved that we always read new words and phrases out loud so I actually knew how to pronounce them. Toma always asked us something about our lives, which made speaking practice feel natural and spontaneous. She also always offered alternative ways to phrase things, which made everything sound more natural and more fancy 💅🏻. Daryna, you had this wonderful balance in everything: the pace, the conversation, the way grammar was explained. It was clear, fun and clever all at the same time. It was super professional. You also always checked if we had questions and made sure we actually got it, what was super cute and clear that you actually care about our results.`,
  },

  {
    name: "iloossha",
    tag: "iloossha",
    pfp: iloossha,
    text: `Well, first and foremost, I really enjoyed this course with every cell of my body 😄

When I started studying here, I didn’t know what to expect. I just wanted real communication, and I got it!

  It was an incredible experience. Yes, sometimes it was difficult to understand something or express my thoughts, but every lesson was interesting and full of useful material.

  It should also be mentioned that you and our previous teachers, Diana and Toma, always explained everything clearly, so we never felt completely lost or confused 😅

I really appreciate you, your support, and all the effort you put into making the lessons engaging and effective.
  I already miss you and my group so much! ❤️`,
  },

  {
    name: "Андрій",
    tag: "aeffir_",
    pfp: aeffir_,
    text: `Overall, I'm really happy with the intensive - it had its easy moments, its hard ones, its fun ones and moments where I had to really push myself. My main goal was to figure out where my gaps are and what I need to explore more deeply. On top of that, over these 3 months I actually built a habit of studying English - and writing this review during what would've been our lesson time, I genuinely feel a bit sad/bad that I didn't sign up for the summer intensive, haha. But for now I want to spend some time working one-on-one (or in duo) with a teacher to address those weak spots, since I still can make mistakes in fairly basic things. But I’m already looking forward to the autumn intensive (which I hope will happen), haha.

Thank you so much for this experience, really. I've been telling all my friends and colleagues about Profound. I'm really glad that Profound is where I restarted my English journey, and I'm definitely not planning on stopping.`,
  },

  {
    name: "bbrvasveth",
    tag: "bbrvasveth",
    pfp: bbrvasveth,
    text: `I have just completed a three-month intensive English course at Profound, and it was a great experience. The course was challenging at times, but I learned a lot and improved my English significantly. What I liked most was the modern teaching approach and the supportive teachers. The lessons were engaging, practical, and very different from the traditional methods I was used to. I enjoyed the course so much that I have already enrolled in the next level and will continue studying for another three months. Thank you to the whole Profound team for making learning English both effective and enjoyable!`,
  },

  {
    name: "Vladislava",
    tag: "vladi.ye",
    pfp: vladi_ye,
    text: `Hi! My feedback:)

I really liked the Spring English Intensive. It was my first experience with group lessons, and I was worried that I might feel uncomfortable, but I was wrong! There are lovely teachers and a great atmosphere during the lessons.

This intensive is a great chance to maintain and improve your English level, but if we talk about improving by a whole level, you definitely need to put in extra effort outside the lessons, surround yourself with English, and practice more.

After this course, I can express my thoughts more quickly and confidently, and I know more vocabulary and grammar. It was fun, useful, and full of positive energy. I’m going to miss these vibes!`,
  },

  {
    name: "Darishka",
    tag: "darishka_semenyuk",
    pfp: darishka_semenyuk,
    text: `Learning English here has been such a great experience! There were moments when it felt easy and moments when it was quite challenging, but it was always interesting and fun. A huge thank you to our teachers for making every class engaging and enjoyable (and for patiently explaining things, answering our sometimes silly questions, and expanding our vocabulary far beyond what was actually in the lessons 😄).

And special thanks to the amazing girls in our group — the vibe was absolutely wonderful, and learning together was a real pleasure. Thank you all for the knowledge, the support, the laughs, and the great memories. ❤️`,
  },

  {
    name: "Dasha",
    tag: "liubarets_dasha",
    pfp: UNK,
    text: `I really enjoyed this three-month intensive course. It was an amazing experience and I can clearly see how much my English has improved. My vocabulary has become much richer, my grammar knowledge is stronger and I feel much more confident when using English.

During the course, I finally understood many grammar topics that had always been difficult for me. These includes: tenses, Passive Voice, Direct and Reported speech, Conditionals, Modal Verbs of Deduction, Separable and Inseparable phrasal verbs etc.

I also learned a lot of useful vocabulary. My favourite topics were Ecology, Crimes, Types of Shops, Stages of Life etc. We also studied a lot of phrasal verbs and other useful expressions that I can now use in everyday communication.

Another thing that I really liked was our teachers!! 🤍 They were always supportive, friendly and genuinely interested in helping us improve. Their attitude made the learning process enjoyable and motivating.

I also loved my group. Before the course started I thought it might be difficult to study in a group because there would not be enough time for everyone. However, I was pleasantly surprised. Every student had the opportunity to participate, answer the questions and receive feedback. The teachers made sure that everyone got enough attention and I always felt involved in the lesson.

Finally, I would like to mention the learning platform. It is very convenient, user-friendly and beautifully designed. I really enjoyed using it throughout the course.`,
  },

  {
    name: "Sofia",
    tag: "shchutiak_",
    pfp: shchutiak_,
    text: `Привіт!
Хотіла би поділитися враженнями від інтенсиву.
Я наважилася на весняний інтенсив, і ні разу про це не пошкодувала.

Спочатку було трохи ніяково, але викладачі завжди нас підтримували і допомагали. Зміна викладачів мене трохи лякала, але насправді кожен з них був чудовим і я завжди себе почувала затишно.

Щодо матеріалу він давався легко, і домашні завдання теж)
ДЗ не задавалися обтяжливими і на їх виконання у мене ішов мінімум часу.

І, найважливіше, я помітила впевненість у своїх знаннях і хоч у мене ще виникають сумніви щодо певних питань але я щаслива що спробувала)`,
  },
  {
    name: "Саша",
    tag: "meinsplitter",
    pfp: meinsplitter,
    text: `Hello)
It was such an amazing time, full of inspiration and fun moments)
The teachers are incredibly cool and friendly💖also, it felt really nice to attend the classes and remember everything I’d forgotten over the years.
I made new friends here, remembered a lot, learned something new and just had a great time🔥`,
  },

  {
    name: "Karina",
    tag: "karina_kuznetsssova",
    pfp: karina_kuznetsssova,
    text: `Studying at Profound School throughout the spring was an incredibly rewarding and enjoyable experience. Over these three months, we gained valuable knowledge, improved our skills, and spent countless hours in a positive, motivating, and supportive learning environment.

I’d like to express our sincere gratitude to our teachers. Each of them contributed greatly to our learning journey with their professionalism, dedication, and unique teaching approach. Their support, encouragement, patience, and positive attitude made every lesson engaging, comfortable, and inspiring.

The classes weren’t only educational but also filled with warmth, humor, and genuine care for students. Thanks to the teachers and the entire Profound team, learning felt both effective and enjoyable.

I wish Profound School continued growth, success, inspiration, and many grateful students in the years to come!`,
  },

  {
    name: "Anastasia",
    tag: "k_stasiaaaa",
    pfp: k_stasiaaaa,
    text: `Hi! I’d like to share my feedback about the course.

To be honest, at the beginning it took me some time to adjust because the format wasn’t exactly what I had expected. But after a while, I stopped comparing my expectations with reality and simply focused on attending the lessons regularly, and that turned out to be the best thing I could do.

As the course went on, I was pleasantly surprised by how much progress I was making. Consistency really does make a difference. Week by week, speaking English became easier and more natural. I also really liked the lesson structure on the platform - everything was well organized and thoughtfully planned. One of my favorite parts was the atmosphere in the group. As we got to know each other better, the conversations became much more natural. We weren’t just completing tasks anymore, we were sharing stories, joking, and actually enjoying the process.

Overall, these three months were intense, engaging, and incredibly rewarding. I challenged myself, and I honestly achieved what I had hoped for. Looking back at my old recordings, I can clearly see how much my English has improved, but even more importantly, how much more confident I’ve become.

I’m very happy with both the course and the teachers. It was obvious how professional, supportive, and involved they all were throughout the program. So for me, this is definitely not goodbye to Profound, cause, I really love you guys and I am planning to continue learning and improving my speaking skills with your team`,
  },

  {
    name: "coff_wo",
    tag: "coff_wo",
    pfp: UNK,
    text: `This course gave me much more than better English. I found a comfortable way to learn, met amazing people, and enjoyed every team session. The atmosphere created by both tutors and students was always positive and motivating.

My main goal was to feel confident speaking English, and I achieved it. Recently, I had my first work call with an American specialist, something I wouldn't have felt ready for before this course.

Thank you for this experience! I'll definitely miss it!`,
  },

  {
    name: "Myroslava",
    tag: "mmir.mira",
    pfp: mmir,
    text: `Hi! As you might have already guessed, I liked the course so much that I decided to take one more. I personally really like the teachers - they are true professionals who give you all the information, resources, and energy you need. One thing I’d like to mention is that they are always there for you! You can write to them for help or ask for extra resources, and they will respond as soon as they can.
The explanations are very clear and easy to understand. And if you don’t get something the first time, they will explain it again and again, and give you some more exercises to practice. I also like the Edio program - it’s super nice and easy to use. The topics are interesting, and the vocabulary is practical! I use it every day. The same goes for grammar! Zoom format is easy to use and very convenient.
I really enjoy the course and learning with you! 🫶🏼👩‍🎓`,
  },
  {
    name: "Denys D.",
    tag: "d.dis_",
    pfp: ddis,
    text: `Hello👋
I would like to share my impressions of the intensive course that I am about to finish soon (B1+ - B2). It was a real chalenge for me, sometimes very difficult, simply because of my level. But I would recommended this intensive for anyone who wants to improve their English. Our teachers were wonderful. There was a good atmosphere. Honestly, I’m going to continue to work with this school, but individually or in pair, because sometimes I really needed more attention from the teacher, which I didn't get. In general - great.

Kind regards
Denys D.`,
  },
  {
    name: "Mariia",
    tag: "m.kukolova",
    pfp: kuko,
    text: `Hi! I really enjoyed the course. I liked that we had a lot of speaking practice and that we learned many grammar topics and new words along the way. I also want to thank our teacher, Diana. She is a real brilliant. If I could choose, I would study with her for all three months. It’s a great project, a great team, and an amazing result.`,
  },
  {
    name: "Альона",
    tag: "miss.fedyniak",
    pfp: fedy,
    text: `I really liked the intensive course (I took B1+B2). My request was to review the basic rules and continue learning the language. 
I would especially like to mention the teacher Diana. The classes were varied, interactive, and fun. We talked a lot, including about our everyday lives, which is important to me personally.

My package also included a free speaking club with Josh, a native speaker, which was a huge plus. We were given themed articles for each lesson to help us prepare! It's important not to be afraid of making mistakes, but to speak up.`,
  },
  {
    name: "Matvii",
    tag: "mat._.t",
    pfp: mat,
    text: `Talking about the course, I would say it’s beneficial, but each student must put in a lot of effort to succeed. Now I feel relief when creating sentences in many different structures. I revised an enormous number of situations where I needed to use a specific idiom. The course creates an ideal environment for studying, bringing together cool people from everywhere. You will like it!`,
  },
  {
    name: "Iрина",
    tag: "rahatfuckinglokum",
    pfp: Ira,
    text: `The best time well spent! 
Everything was incredible: the teachers, the lessons, my group, and the overall atmosphere.
At first, I thought it would be easy since I already knew most of the material, but it turned out that my knowledge had many deeper layers. I literally went through all the stages of acceptance while working on my weak spots)
I truly enjoyed every lesson
These three months of English were absolutely amazing!`,
  },
  {
    name: "Борис",
    tag: "boris_britva_____",
    pfp: bor,
    text: `Hello, the course is great, it was a really delightful challenge. Unfortunately, I don’t have much time at the moment and there is a chance I won’t finish all the homework because work has been very stressful and demanding. The certificate isn’t necessary for me, so it’s completely fine if I don’t receive it`,
  },
  {
    name: "Марія",
    tag: "mari.hut",
    pfp: mar,
    text: `Hi, i want to leave my review on course i had passed. I really enjoyed the time i've spent together with my group and tutors, even though i had pretty hard time in my life i still enjoyed our little routine. I've learned a lot of new things i find usuful for my life. I hope I'll join to some of your classes soon!`,
  },
  {
    name: "mytia_heorhiiovych",
    tag: "mytia_heorhiiovych",
    pfp: myt,
    text: `Thanks to everyone for this intensive course - it was great🫶🏻`,
  },
  {
    name: "Anna",
    tag: "anniemediuk",
    pfp: an,
    text: `Hi, I want to say you thank you for this perfect opportunity,
I really enjoyed the intensive course. I started to feel more confident in grammar. I liked working on the platform and doing exercises every day. I also noticed that my English has improved. It was sometimes hard to keep up with daily attendance, but this way you can’t relax too much and you will definitely achieve results`,
  },

  {
    name: "СОФІЙКА",
    tag: "sonicka.o",
    pfp: sof,
    text: `Hi, I want to say several words about this course. Honestly, I am absolutely pleased with it. This course was so useful and comfortable. I have already got this confidence in speaking and I’m not afraid of that anymore. I hope that I participate in another course.
One interesting fact: in this course I found Bene and eventually I want to continue learning English with her, she impressed me🥹. So, in your school everyone can feel this cozy vibe. Many thanks!🫶🏻`,
  },
  {
    name: "Іра",
    tag: "bbyrusya",
    pfp: ir,
    text: `Over these three months of studying on the course, really I felt progress! I started speaking English more confidently, stopped being afraid of making mistakes, and grammar finally became clear and more logical for me. Especially, I want to highlight the teachers: each of them was so patient, explained complicated things in simple words, and was always ready to help or repeat the material again if needed. The intensive course really motivated me to keep learning, not stop and not be afraid of difficulties. Yes, sometimes it was challenging, but when you see your own progress and compare yourself now to who you were just a month ago, it motivates you even more. I’m incredibly grateful for such a wonderful team of teachers and their approach to teaching. The intensive format is truly effective, especially for people who want to quickly improve their English level - whether for university admission or future career growth. Everything was clear, structured, and so effective!`,
  },
  {
    name: "Yercules",
    tag: "yarkules",
    pfp: UNK,
    text: `Вітаю!

Хочу щиро подякувати школі Profound за неймовірний досвід навчання. Це місце, де тебе не просто навчають — тебе підтримують, мотивують і допомагають рости кожного дня.

Особлива подяка викладачам Марії, Лєрі та Руслані. У кожного з них свій стиль, але всіх об’єднує одне — професіоналізм і справді людяний, індивідуальний підхід до кожного студента. Вони вміють пояснити складне простими словами, підлаштувати урок під твій рівень і настрій, і завжди знайдуть спосіб, щоб ти відчував прогрес та впевненість у собі.
Гнучкість викладачів та їхнє бажання адаптувати навчання під потреби кожного — це те, що робить школу особливою.

Атмосфера в школі тепла, дружня та дуже мотивуюча. Кожен урок проходить легко, з усмішкою, але водночас суперпродуктивно. Я відчуваю реальний результат і з нетерпінням чекаю кожного наступного заняття.

Щиро рекомендую всім, хто хоче вивчати англійську з задоволенням, у комфортній атмосфері та з викладачами, які дійсно вміють навчати та надихати.
Дякую вам за все, ви найкращі! 💛✨`,
  },
  {
    name: "Ігор",
    tag: "ingvarrn",
    pfp: ihor,
    text: `This is my second course and I’ve been attending it for half a year. There are plenty of great people here who are genuinely passionate about teaching. At the beginning, the intensity and the amount of new material can feel daunting. Nonetheless, the course is easy-going and rewarding if you manage not give up and actually finish it. 
Looking back, I’m glad I stayed with the course because the progress feels real.`,
  },
  {
    name: "Marionella",
    tag: "me.mozzarella",
    pfp: marion,
    text: `Overall, I would say I can definitely see and feel the progress both in my speaking and my vocabulary. I notice so many words from the series and movies now that we have learned during the course. I can see myself using new phrases and words at work. Of course, it was hard to keep up with the course and cover the language focus, grammar and vocabulary on an excellent level. But it still pushed my English to the upper level. I'm grateful for the course and the guidance from all the teachers, and I hope my feedback will be useful!`,
  },
  {
    name: "Illia",
    tag: "karpenko.lllia",
    pfp: illa,
    text: `The intensive course is just incredible🚀
Thank you and your team for such dedication during the classes
All my questions were answered. There were very clear explanations of tough topics and lots of practice to master them
The platform looks great and has wide functionality and a very user-friendly experience
Special thanks for the Speaking Club with Josh - it’s very valuable speaking practice with a native speaker🤝`,
  },
  {
    name: "alinasytnikk",
    tag: "alinasytnikk",
    pfp: al,
    text: `hi) I want to thank you for the intensive course that I took. It was really interesting and useful. Now I know that I can learn hard, my speaking skills have grown and I feel more confident than before. Especially thank Bene, she is really cool teacher!)`,
  },
  {
    name: "Olya",
    tag: "olyatishchenko",
    pfp: olya,
    text: `Hi!
I honestly loved this English intensive. The classes were dynamic and never boring 😁. The teachers were incredible (Lera, Anya and Liza 🫶🏻) - always in touch, always ready to help, and always explained even the hard things in a clear, easy way. I really felt supported the whole time, and I actually enjoyed the process. Highly recommend this course to anyone who wants progress and a good vibe!`,
  },
  {
    name: "Nadiia",
    tag: "yadan.ok",
    pfp: yadan,
    text: `Hello! I would like to leave a feedback on the autumn intensive course, I hope it's not too late. First of all, I would like to mention that I will miss these meetings four times a week every evening, as well as the group and the teachers. This intensive course gave me an incredible routine that I wanted to return to every time. I went to every lesson with pleasure and the awareness that this time would be spent with great benefit. Every month, we had a new teacher with her own unique vibe and approach to teaching. And every time the teacher changed, a kind of void formed in our hearts for a moment, which was immediately filled with a whirlwind of new incredible emotions. 
We started learning with Maria, who gave us her calmness, who carefully organised the learning process, and helped us get to know each other and bond as a group. 
In October, Lera joined us. We devoted a lot of time to grammar, and she meticulously ensured that all the necessary words have the right "stress" and are used in the correct "connotation". 
Those two months flew by very quickly. Before we knew it, November had arrived, and with it, power outages. To be honest, I had no idea how we would be able to attend classes in such conditions.
But then Ruslana showed up with her daisy behind her ear, bringing comfort and warmth. We learned a lot of new and interesting vocabulary, how to use the Cambridge dictionary, and much more. It's amazing how much we managed to do during her lessons. It was an incredible time.
Only a few days have passed, and I already miss studying. I hope we will meet again someday❤️❤️❤️`,
  },
  {
    name: "Igor",
    tag: "igor.chibo",
    pfp: igor,
    text: `Personally for me this course was very helpful.It was my first course at this level.
Thakns You guys for your professional attitude and skills shared !`,
  },
  {
    name: "Tate Lee",
    tag: "tatinka_lee",
    pfp: tat,
    text: `Good evening!
I was studying in your intensive course from A2 to B1. For me it was a very useful course, because I learned a lot of grammar and many new words that I didn’t know before. But I can also say that the course confused me a little, because every month we changed not only the teachers but also the program.

In the third month we almost didn’t have normal homework. We only had writing practice, and that was all.

So, the course was really helpful for me personally. I started to speak more confidently, faster, and with better grammar. But I also saw a problem with the course, because during the last month and a half I felt that it became too boring.`,
  },
  {
    name: "Ярослава",
    tag: "yrslva.shtnk",
    pfp: yar,
    text: `Hello, I want to share my experience about autumn intensive course. It was incredible! Finally, I’m not afraid of speaking and creating my own texts (it was my aim for this course). Yes, sometimes it felt very difficult, but it is worth it. I’m very grateful for this format, because I began to like English and to want to learn more. This format helped me to find lovely people and to understand—English isn’t scary if you learn it in pleasant atmosphere.`,
  },
  {
    name: "Альона",
    tag: "miss.fedyniak",
    pfp: alyona,
    text: `I really liked the intensive course (I took B1+B2). My request was to review the basic rules and continue learning the language. 
I would especially like to mention the teacher Diana. The classes were varied, interactive, and fun. We talked a lot, including about our everyday lives, which is important to me personally.

My package also included a free speaking club with Josh, a native speaker, which was a huge plus. We were given themed articles for each lesson to help us prepare! It's important not to be afraid of making mistakes, but to speak up.`,
  },

  {
    name: "Надія",
    tag: "yadan.ok",
    pfp: nad,
    text: `Hello! I would like to leave a feedback on the autumn intensive course, I hope it's not too late. First of all, I would like to mention that I will miss these meetings four times a week every evening, as well as the group and the teachers. This intensive course gave me an incredible routine that I wanted to return to every time. I went to every lesson with pleasure and the awareness that this time would be spent with great benefit. Every month, we had a new teacher with her own unique vibe and approach to teaching. And every time the teacher changed, a kind of void formed in our hearts for a moment, which was immediately filled with a whirlwind of new incredible emotions. 
We started learning with Maria, who gave us her calmness, who carefully organised the learning process, and helped us get to know each other and bond as a group. 
In October, Lera joined us. We devoted a lot of time to grammar, and she meticulously ensured that all the necessary words have the right "stress" and are used in the correct "connotation". 
Those two months flew by very quickly. Before we knew it, November had arrived, and with it, power outages. To be honest, I had no idea how we would be able to attend classes in such conditions.
But then Ruslana showed up with her daisy behind her ear, bringing comfort and warmth. We learned a lot of new and interesting vocabulary, how to use the Cambridge dictionary, and much more. It's amazing how much we managed to do during her lessons. It was an incredible time.
Only a few days have passed, and I already miss studying. I hope we will meet again someday❤️❤️❤️`,
  },
  {
    name: "Анастасія",
    tag: "hrammma",
    pfp: Anas,
    text: `Hey!! 

Honestly, I came for the English but stayed for the vibe 😄 The lessons are not just about grammar rules (although those are sneaked in too), it actually feels like hanging out with a smart friend who secretly makes you smarter. 10/10 would recommend — my English got better and my mood too!`,
  },
  {
    name: "Катерина",
    tag: "katelosinska",
    pfp: Kat,
    text: `Я б хотіла написати цілу оду Тані 🙏🏻 Просто неймовірна жінка, дуже приємно приходити на уроки, які чекаєш з нетерпінням. Ніколи не відчувала такого комфорту на заняттях. На уроках все прекрасно пояснює, максимальна інтеграція на групових заняттях, неймовірна підтримка і цікаві теми/уроки, + багато speaking i writing на домашнє завдання що особисто для мене дуже важливо і дуже подобалось. Свій перший прогрес на курсі присвячую їй 🙂‍↕️`,
  },
  {
    name: "w.axler",
    tag: "w.axler",
    pfp: Axler,
    text: `Hi🥹
I would like to write some words about the summer intensive course)) 
this is my first time studying at Profound, and I’m very happy I decided to join this course🥹🥰
Overall, I really like our teachers, Lera and Maria are excellent. Every student gets enough attention, and I can see that the teachers have a very strong understanding of methodology. I’m extremely satisfied, thank uuu!!☺️`,
  },
  {
    name: "Вероніка",
    tag: "_veronika_bad",
    pfp: ver,
    text: `Hi, I want to write a feedback about course! So it’s an awesome journey with both our teachers that we already had (Maria and Lera). Also we have a cool atmosphere in the group, everyone so nice, friendly and interesting. It’s great to be out of comfort zone and try your best in new surrounding💓`,
  },
  {
    name: "Дарина",
    tag: "dari_foh",
    pfp: UNK,
    text: `Thank you for the lessons, now I feel more confident about my English level and going to achieve more🫶`,
  },
  {
    name: "ingvarrn",
    tag: "ingvarrn",
    pfp: inv,
    text: `I never get bored in class, which helps me stay motivated and enjoy the process. The balance between grammar and speaking practice really works for me. The friendly vibe and occasional jokes definitely help keep the brain awake:)`,
  },
  {
    name: "Анастасія",
    tag: "nastyamokinaa",
    pfp: nast,
    text: `Залітаю в «останній вагон» 
Отже, інтенсивний курс - досить інтенсивний😅. Інколи буває досить складно, інколи легко. В загальному я задоволена структурою уроків, змістовністю і взагалі edio (навіть з багами😅) , також зміна викладачів теж цікавий досвід бо не звикаєш до одної людини , її вимови і тд. I have nothing to add тому що мене все влаштовує і я задоволена навчанням🤘🏼
Забула додати , спочатку думаєш що 4/р. на тиждень це «забагато», але після ти настільки звикаєш , до дівчат , до викладачів ,до темпу навчання що не можеш дочекатись початок наступного тижня☺️
`,
  },

  {
    name: "Дастан",
    tag: "dastanberdikulov",
    pfp: dast,
    text: `Я приєднався до інтенсиву з англійської з чіткою метою — знайти роботу за кордоном. З самого початку це був виклик: говорити було невпевнено, бракувало практики. Але завдяки постійним розмовним сесіям, дружній атмосфері на кожному занятті та крутій спільноті, я прокачав свою англійську і став говорити набагато впевненіше. Як результат — я отримав роботу за кордоном. Жодного разу не пошкодував, що обрав саме цей інтенсив!`,
  },
  {
    name: "Яна",
    tag: "y.hulyk",
    pfp: yana,
    text: `Heey, so sorry for not leaving my feedback about the course, I’ll do now! 
I really enjoy this English course, the lessons are interesting and the teachers are incredible; I’ve learned a lot of new information, vocabulary and grammar; the speaking topics are pretty thought-provoking. Unfortunately, I can join the class just two times per week (because of work..) but there’re recordings after each class, so that’s easy to catch up with the rest of our group.
In a nutshell, I loveee it!🫶🏽`,
  },
  {
    name: "Дар'я",
    tag: "_____dmmmnnts.life___",
    pfp: UNK,
    text: `Summer Drill is the most interesting club I have ever taken part in. 😌

I really enjoy the teachers, and the fact that they change every month is fantastic. ✨This rotation keeps every lesson fresh and motivating and I can go out of my comfort zone 🙃Lessons are always engaging, with varied topics and well-prepared materials. Before joining your program, my experience with group classes was not very good. However, in your intensive course, the hour goes by quickly and feels very relaxed.
Thank you to you and your team for creating such a friendly and supportive atmosphere where I can learn English 🔥🔥🔥
`,
  },
  {
    name: "Вадім",
    tag: "vadim_hordiichuk",
    pfp: vadim,
    text: `Інстесив топ 
Знаю як буде - обрізання, англійською 
В групі веселіше і реально вчишся на чужих помилках! 
Граматика сама в процесі переварюється, а розмовна за рахунок группи розширюється, не тільки -like that, like this, що реально круто . 
Як я зрозумів що буставнувся ? 
В онлайн ігри впевнено тушу іноземців, бо на ємоціях лізе мова на якій впевнено розмовляешь!`,
  },
  {
    name: "Анна",
    tag: "dr.anna.kolesnyk",
    pfp: anna,
    text: `Хочу вам подякувати за такий крутий інтенсив, вже пройшло майже два місяці навчання і я точно можу сказати,що мої скіли значно покращились. 

Для мене це не просто мовна школа — це середовище, де тебе навчають думати англійською, розмовляти впевнено і розширювати кругозір.

Використовуються якісні інтерактивні платформи та матеріали — усе виглядає сучасно, зручно і продумано. Для мене ця візуальна складова дуже важлива.

Викладачі це просто 🔥 Особливо ціную живий контакт, гумор і щиру зацікавленість у прогресі студентів. 

Розмовна практика — на висоті. Було багато speaking club’ів, парної роботи, обговорень тем, які справді хочеться обговорювати, а не просто зубрити фрази. Завдяки цьому вийшла з мовного «ступору» й почала говорити вільніше.

Дуже дякую вам за цей осінній інтенсив🤍🤍🤍
`,
  },
];

function ReviewCard({ item, expanded = false, onShowMore }) {
  return (
    <div
      className={[styles.block, expanded && styles.expandedBlock]
        .filter(Boolean)
        .join(" ")}
    >
      <a
        href={`https://www.instagram.com/${item.tag}/`}
        target={"_blank"}
        rel="noreferrer"
        className={styles.user}
      >
        <img src={item.pfp} alt={item.name} />
        <div>
          <div>{item.name}</div>
          <span>@{item.tag}</span>
        </div>
      </a>

      <Clampable
        expanded={expanded}
        onShowMore={onShowMore}
        className={styles.reviewText}
      >
        {item.text}
      </Clampable>
    </div>
  );
}

export default function Review() {
  return (
    <div className={styles.container} id={"feedback"}>
      <CardSlider
        title="Відгуки"
        headClassName={styles.title}
        headerArrowsOnMobile
        items={feedback}
        settings={{ autoplay: true, autoplaySpeed: 5000 }}
        renderCard={(item, { onShowMore }) => (
          <ReviewCard item={item} onShowMore={onShowMore} />
        )}
        renderExpanded={(item) => <ReviewCard item={item} expanded />}
      />
    </div>
  );
}
